import YoloLogoIcon from 'assets/logo/yolorekt_logo_h1.svg'
import YoloLogoWhiteIcon from 'assets/logo/yolorekt_logo_inline_FFF_134x25.png'
import YoloBetaLogoIcon from 'assets/logo/yolorekt_beta_logo.svg'
import YoloTokenWhiteIcon from 'assets/logo/yolorekt_moon-white.svg'
import YoloXftLogo from 'assets/logo/yolo_xft_logo.svg'
import LoadingMoon from 'assets/logo/loadingMoon.png'
import ProjectGalaxyLogo from 'assets/logo/project_galaxy_logo-white-hor.svg'

import YoloHoleIcon from 'assets/icons/yolorekt_logo_holes.svg'
import MoonIcon from 'assets/icons/moon_icon.svg'
import AboutIcon from 'assets/icons/about_icon.png'
import MenuIcon from 'assets/icons/nav_menu_icon.svg'
import MobileMenuIcon from 'assets/icons/menu-theme-dark_icon.svg'
import MetaMaskIcon from 'assets/icons/metamask_icon.svg'
import metamask_icon from 'assets/icons/metamask_icon.svg'
import copy_icon from 'assets/icons/copy_icon.svg'
import copy_icon_white from 'assets/icons/copy_icon-white.svg'
import copy_image_icon from 'assets/icons/copy_image_icon.svg'
import download_icon from 'assets/icons/download_icon.svg'
import YoloTokenIcon from 'assets/icons/yolo_token_icon.svg'
import yolo_token from 'assets/icons/yolo_token_icon.svg'
import PendingIcon from 'assets/icons/pending_icon.svg'
import CheckCircleIcon from 'assets/icons/check_icon.svg'
import check_icon from 'assets/icons/check_icon.svg'
import dollarIcon from 'assets/icons/dollar.icon.svg'
import dollarCircleIcon from 'assets/icons/dollar_circle.icon.svg'
import DecryptIcon from 'assets/img/decrypt_icon.png'
import VeradiIcon from 'assets/img/veradiverdict_icon.png'
import ForbesIcon from 'assets/img/forbes_icon.png'
import TimeIcon from 'assets/icons/time_icon.svg'
import DialGaugeIcon from 'assets/icons/gauge_dial-top.svg'
import GaugePointerIcon from 'assets/icons/gauge_center.svg'
import EnlargeIcon from 'assets/icons/enlarge_icon.svg'
import CareerIcon from 'assets/img/careers_icon.svg'
import CrownIcon from 'assets/icons/crown_icon.svg'
import ArrowExpandIcon from 'assets/icons/arrow_expand_icon.svg'

import LiveGameIcon from 'assets/icons/live_game_gray.png'
import LiveGameHoverIcon from 'assets/icons/live_game_hover.png'
import LiveStatsIcon from 'assets/icons/live_stats_gray.svg'
import LiveStatsHoverIcon from 'assets/icons/live_stats_hover.svg'
import LiveText from 'assets/icons/live_text.svg'
import ChatIcon from 'assets/icons/chat_gray.svg'
import ChatHoverIcon from 'assets/icons/chat_hover.svg'
import PlusIcon from 'assets/icons/plus_icon.svg'
import MinusIcon from 'assets/icons/minus_icon.svg'

import PolygonIcon from 'assets/icons/polygon_icon.svg'
import PolygonLogoIcon from 'assets/icons/polygon-logo.svg'
import EqualThinIcon from 'assets/icons/equal_thin_icon.svg'
import equal_thin_icon from 'assets/icons/equal_thin_icon.svg'
import LightPaperIcon from 'assets/icons/litepaper_icon.png'
import ArrowUpIcon from 'assets/icons/arrow_up.svg'
import arrow_up from 'assets/icons/arrow_up.svg'
import ArrowIcon from 'assets/icons/arrow.png'
import MoveIcon from 'assets/icons/move.png'
import CoinIcon from 'assets/icons/coin.png'
import AvatarIcon from 'assets/icons/avatar1.png'
import EndedIcon from 'assets/icons/ended.png'
import SliderArrowIcon from 'assets/icons/game_browser_arrow.svg'
import CubicIcon from 'assets/icons/cubic.png'
import MsgEndLeftIcon from 'assets/icons/chat_end-left.svg'
import MsgEndRightIcon from 'assets/icons/chat_end-right.svg'
import MsgSendBtnIcon from 'assets/icons/send_button_icon.svg'
import ChainLinkIcon from 'assets/icons/chainlink_icon.svg'
import LiveBidsMeterIcon from 'assets/icons/live_bids_meter.svg'
import MeterNeedleIcon from 'assets/icons/meter_needle.svg'
import UserIcon from 'assets/icons/user_icon.svg'
import BetaBadgeIcon from 'assets/icons/beta_badge.png'
import BidUpIcon from 'assets/icons/bid_up_icon.svg'
import BidDownIcon from 'assets/icons/bid_down_icon.svg'
import SadFaceIcon from 'assets/icons/sad_face_icon.svg'
import ChatYoloIcon from 'assets/icons/avatar_icon_blue.svg'
import ChatYoloGrayIcon from 'assets/icons/avatar_icon_gray.svg'
import ThreeDotsIcon from 'assets/icons/three-dots.svg'
import BlockIcon from 'assets/icons/block_icon.svg'
import QuestionIcon from 'assets/icons/question_icon.svg'
import ErrorIcon from 'assets/icons/error_icon.svg'
import CloseCircleIcon from 'assets/icons/close_modal.svg'
import CloseIcon from 'assets/icons/close_icon_2.svg'
import close from 'assets/icons/close_circle_border.svg'
import CheckMark from 'assets/icons/check-mark.svg'

import YenIcon from 'assets/icons/yen_icon.svg'

import ComingUpGraphImg from 'assets/icons/comingup_graph.png'

import YoloNftGold from 'assets/icons/yolo_nft-gold.png'
import YoloNftEmerald from 'assets/icons/yolo_nft-emerald.png'
import YoloNftBlue from 'assets/icons/yolo_nft-blue.svg'
import YoloNftRose from 'assets/icons/yolo_nft-rose.png'
import YoloNftRuby from 'assets/icons/yolo_nft-ruby.png'
import YoloNftSilver from 'assets/icons/yolo_nft-silver.png'
import YoloNftOrchid from 'assets/icons/yolo_nft-orchid.png'
import YoloNftDiamond from 'assets/icons/yolo_nft-diamond.png'

import CheckBlue from 'assets/icons/check_icon-blue.svg'
import AlertRed from 'assets/icons/alert_icon-red.svg'
import CheckCircle from 'assets/icons/check_icon.svg'
import PendingYellow from 'assets/icons/pending_icon-yellow.svg'
import UnstoppableDomainsLogo from 'assets/icons/unstoppable_domains_logo-dark.svg'
import xftFramed from 'assets/icons/xft_icon-only.svg'
import MaticIcon from 'assets/icons/matic_currency_icon.svg'
import MaticIconHole from 'assets/icons/matic_currency_icon_hole.svg'
import GameStopIcon from 'assets/icons/gamestop_icon.svg'
import usdc from 'assets/icons/usdc.svg'
import deposit_icon from 'assets/icons/deposit_icon.svg'
import withdraw_icon from 'assets/icons/withdraw_icon.svg'
import info_icon from 'assets/icons/info_icon.svg'
import panel_collapse_icon from 'assets/icons/panel_collapse_icon.svg'
import events_icon from 'assets/icons/events_icon.svg'
import events_icon_white from 'assets/icons/events_icon_white.svg'
import short_term_prediction_icon from 'assets/icons/short_term_prediction_icon.svg'
import yolo_days_icon from 'assets/icons/yolo_days_icon.svg'
import perpetual_futures_icon from 'assets/icons/perpetual_futures_icon.svg'
import swap_direction_icon from 'assets/icons/swap_direction_icon.svg'
import direction_arrow_icon from 'assets/icons/direction_arrow_icon.svg'
import close_x_icon from 'assets/icons/close_x_icon.svg'
import bid_direction_icon from 'assets/icons/bid_direction_icon.svg'
import bid_direction_up_icon from 'assets/icons/bid_direction_up_icon.svg'
import bid_direction_down_icon from 'assets/icons/bid_direction_down_icon.svg'
import bid_direction_neutral_icon from 'assets/icons/bid_direction_neutral_icon.svg'
import YoloLogoVerticalWhiteIcon from 'assets/icons/yolorekt_logo_vertical_white_icon.svg'
import crosshair_yellow_18 from 'assets/icons/crosshair_yellow_18.png'
import avatarDefault from 'assets/icons/user_icon.svg'
import close_window_icon from 'assets/icons/close_window_icon.svg'
import bid_success_icon from 'assets/icons/bid_success_icon.svg'
import bid_success_black_icon from 'assets/icons/bid_success_black_icon.svg'
import bid_error_icon from 'assets/icons/bid_error_icon.svg'
import error_icon from 'assets/icons/error_icon.svg'
import bid_warning_icon from 'assets/icons/bid_warning_icon.svg'
import warning_icon_solid_orange from 'assets/icons/warning_icon_solid-orange.svg'
import warning_icon_solid_red from 'assets/icons/warning_icon_solid-red.svg'
import bid_info_icon from 'assets/icons/bid_info_icon.svg'
import TwitterIcon from 'assets/icons/twitter_icon.svg'
import twitter_icon from 'assets/icons/twitter_icon.svg'
import twitter_icon_blue from 'assets/icons/twitter_icon_blue.svg'
import telegram_icon from 'assets/icons/telegram_icon.svg'
import discord_icon from 'assets/icons/discord_icon.svg'
import default_avatar_square from 'assets/icons/default_avatar-square.svg'
import pandl_up_icon from 'assets/icons/pandl_up_icon.svg'
import closed_order_icon from 'assets/icons/closed_order_icon.svg'
import funding_order_icon_profit from 'assets/icons/funding_order_icon_profit.svg'
import funding_order_icon_loss from 'assets/icons/funding_order_icon_loss.svg'
import sg_box_arrow_up from 'assets/icons/sg_box_arrow-up.png'
import sg_box_arrow_down from 'assets/icons/sg_box_arrow-down.png'
import search_icon from 'assets/icons/search_icon.svg'
import rank_1_icon from 'assets/icons/rank_1_icon.svg'
import open_bid_icon_green from 'assets/icons/open_bid_icon-green.svg'
import open_bid_icon_red from 'assets/icons/open_bid_icon-red.svg'
import edit_icon from 'assets/icons/edit_icon.svg'
import chat_icon from 'assets/icons/chat_icon.svg'
import wallet_icon from 'assets/icons/wallet_icon.svg'
import calculator_icon from 'assets/icons/calculator_icon.svg'
import busted_icon from 'assets/icons/busted_icon.svg'
import cashed_out_icon_profit from 'assets/icons/cashed_out_icon-profit.svg'
import cashed_out_icon_loss from 'assets/icons/cashed_out_icon-loss.svg'
import cashout_icon_green from 'assets/icons/cashout_icon-green.svg'
import cashout_icon_red from 'assets/icons/cashout_icon-red.svg'
import share_icon from 'assets/icons/share_icon.svg'
import wsb_icon_1 from 'assets/icons/wsb_icon_1.png'
import reddit_icon from 'assets/icons/reddit_icon.svg'
import external_link_icon from 'assets/icons/external_link_icon.svg'
import reddit_karma_icon from 'assets/icons/reddit_karma_icon.png'
import reddit_cakeday_icon from 'assets/icons/reddit_cakeday_icon.png'
import clone_bid_icon from 'assets/icons/clone_bid_icon.svg'
import linked_icon from 'assets/icons/linked_icon.svg'

import spy_icon_transparent from 'assets/icons/spy_icon-transparent.svg'
import eth_icon_hole from 'assets/icons/eth_icon-hole.svg'
import tesla_icon_hole from 'assets/icons/tesla_icon-hole.svg'

import chat_info_icon from 'assets/icons/chat_info_icon.svg'
import chat_emojis_icon from 'assets/icons/chat_emojis_icon.svg'
import chat_gifs_icon from 'assets/icons/chat_gifs_icon.svg'
import image_icon from 'assets/icons/image_icon.svg'
import high_low_icon from 'assets/icons/high_low_icon.svg'
import credit_card_icon from 'assets/icons/credit_card_icon.svg'
import unclone_bid_icon from 'assets/icons/unclone_bid_icon.png'
import remove_icon from 'assets/icons/remove_icon.svg'
import clone_bid_icon_toast from 'assets/icons/clone_bid_icon-toast.svg'
import clone_bid_icon_toast_stopped from 'assets/icons/clone_bid_icon-toast-stopped-cloning.svg'
import new_icon_bca from 'assets/icons/new_icon_bca.svg'
import new_icon_yc from 'assets/icons/new_icon_yc.svg'
import new_icon_green from 'assets/icons/new_icon_green.svg'
import new_icon_yellow from 'assets/icons/new_icon_yellow.svg'
import new_icon_purple from 'assets/icons/new_icon_purple.svg'
import leveraged_crypto_icon from 'assets/icons/leveraged_crypto_icon.svg'
import leveraged_indexes_icon from 'assets/icons/leveraged_indexes_icon.svg'
import leveraged_synth_stocks_icon from 'assets/icons/leveraged_synth_stocks_icon.svg'

import tier_diamond from 'assets/icons/tier_diamond.svg'
import tier_gold from 'assets/icons/tier_gold.svg'
import tier_silver from 'assets/icons/tier_silver.svg'

import get_link_icon from 'assets/icons/get_link_icon.svg'
import invite_friends_icon from 'assets/icons/invite_friends_icon.svg'
import start_earning_icon from 'assets/icons/start_earning_icon.svg'

import vesting_icon from 'assets/icons/vesting_icon.svg'
import unlock_icon from 'assets/icons/unlock_icon.svg'
import total_token_all_icon from 'assets/icons/total_token_all_icon.svg'
import token_price_icon from 'assets/icons/token_price_icon.svg'
import token_icon from 'assets/icons/token_icon.svg'
import team_allocation_icon from 'assets/icons/team_allocation_icon.svg'
import tax_icon from 'assets/icons/tax_icon.svg'
import supply_icon from 'assets/icons/supply_icon.svg'
import seed_investors_allocation_icon from 'assets/icons/seed_investors_allocation_icon.svg'
import min_buy_amount_icon from 'assets/icons/min_buy_amount_icon.svg'
import mechanism_icon from 'assets/icons/mechanism_icon.svg'
import info_icon_circle from 'assets/icons/info_icon.svg'
import date_icon from 'assets/icons/date_icon.svg'
import ai_indexes_icon from 'assets/icons/ai_indexes_icon.svg'
import new_icon_game from 'assets/icons/new_icon-game.svg'
import beta_icon from 'assets/icons/beta_icon.svg'
import ach_check_checked_3 from 'assets/icons/ach_check-checked-3.svg'
import ach_check_unchecked_3 from 'assets/icons/ach_check-unchecked-3.svg'
import ach_check_checked_3_dark from 'assets/icons/ach_check-checked-3-dark.svg'

export const icons = {
  funding_order_icon_profit,
  funding_order_icon_loss,
  AboutIcon,
  YoloLogoIcon,
  YoloTokenWhiteIcon,
  YoloLogoWhiteIcon,
  YoloBetaLogoIcon,
  YoloHoleIcon,
  YoloXftLogo,
  ProjectGalaxyLogo,
  LoadingMoon,
  eth_icon_hole,
  TimeIcon,
  CoinIcon,
  AvatarIcon,
  EndedIcon,
  PolygonIcon,
  SliderArrowIcon,
  CubicIcon,
  PolygonLogoIcon,
  MoonIcon,
  MenuIcon,
  MobileMenuIcon,
  MetaMaskIcon,
  EnlargeIcon,
  copy_icon,
  copy_icon_white,
  copy_image_icon,
  download_icon,
  YoloTokenIcon,
  yolo_token,

  EqualThinIcon,
  LiveBidsMeterIcon,
  CloseCircleIcon,
  CloseIcon,
  close,
  PendingIcon,
  CheckCircleIcon,
  check_icon,
  dollarIcon,
  dollarCircleIcon,
  CheckMark,
  DecryptIcon,
  VeradiIcon,
  ForbesIcon,
  LightPaperIcon,
  CareerIcon,
  ArrowUpIcon,
  arrow_up,
  ArrowIcon,
  MoveIcon,
  LiveGameIcon,
  LiveGameHoverIcon,
  LiveStatsIcon,
  LiveStatsHoverIcon,
  LiveText,
  MeterNeedleIcon,
  ChatIcon,
  DialGaugeIcon,
  UserIcon,
  GaugePointerIcon,
  MsgSendBtnIcon,
  MsgEndLeftIcon,
  MsgEndRightIcon,
  ChainLinkIcon,
  ChatHoverIcon,
  CrownIcon,
  BetaBadgeIcon,
  BidUpIcon,
  BidDownIcon,
  SadFaceIcon,
  tesla_icon_hole,
  YenIcon,
  ArrowExpandIcon,
  ChatYoloIcon,
  ChatYoloGrayIcon,
  ThreeDotsIcon,
  BlockIcon,
  QuestionIcon,
  ErrorIcon,
  PlusIcon,
  MinusIcon,
  ComingUpGraphImg,
  YoloNftGold,
  YoloNftEmerald,
  YoloNftBlue,
  YoloNftRose,
  YoloNftRuby,
  YoloNftSilver,
  YoloNftOrchid,
  YoloNftDiamond,
  CheckBlue,
  AlertRed,
  CheckCircle,
  PendingYellow,
  UnstoppableDomainsLogo,
  xftFramed,
  MaticIcon,
  MaticIconHole,
  GameStopIcon,
  usdc,
  deposit_icon,
  withdraw_icon,
  info_icon,
  spy_icon_transparent,
  panel_collapse_icon,
  events_icon,
  events_icon_white,
  short_term_prediction_icon,
  yolo_days_icon,
  perpetual_futures_icon,
  swap_direction_icon,
  direction_arrow_icon,
  close_x_icon,
  bid_direction_icon,
  bid_direction_up_icon,
  bid_direction_down_icon,
  bid_direction_neutral_icon,
  YoloLogoVerticalWhiteIcon,
  crosshair_yellow_18,
  avatarDefault,
  close_window_icon,
  bid_success_icon,
  bid_success_black_icon,
  bid_error_icon,
  bid_warning_icon,
  bid_info_icon,
  TwitterIcon,
  twitter_icon,
  twitter_icon_blue,
  telegram_icon,
  discord_icon,
  warning_icon_solid_orange,
  warning_icon_solid_red,
  default_avatar_square,
  sg_box_arrow_up,
  sg_box_arrow_down,
  pandl_up_icon,
  closed_order_icon,
  open_bid_icon_green,
  open_bid_icon_red,
  search_icon,
  rank_1_icon,
  chat_info_icon,
  chat_emojis_icon,
  chat_gifs_icon,
  edit_icon,
  image_icon,
  chat_icon,
  calculator_icon,
  high_low_icon,
  busted_icon,
  cashed_out_icon_profit,
  cashed_out_icon_loss,
  cashout_icon_green,
  cashout_icon_red,
  share_icon,
  wsb_icon_1,
  reddit_icon,
  external_link_icon,
  reddit_karma_icon,
  reddit_cakeday_icon,
  clone_bid_icon,
  linked_icon,
  wallet_icon,
  credit_card_icon,
  unclone_bid_icon,
  remove_icon,
  clone_bid_icon_toast,
  clone_bid_icon_toast_stopped,
  new_icon_bca,
  new_icon_yc,
  leveraged_crypto_icon,
  leveraged_indexes_icon,
  leveraged_synth_stocks_icon,
  new_icon_green,
  new_icon_yellow,
  new_icon_purple,
  tier_diamond,
  tier_gold,
  tier_silver,
  get_link_icon,
  invite_friends_icon,
  start_earning_icon,
  token_icon,
  info_icon_circle,
  tax_icon,
  unlock_icon,
  vesting_icon,
  total_token_all_icon,
  token_price_icon,
  team_allocation_icon,
  supply_icon,
  seed_investors_allocation_icon,
  min_buy_amount_icon,
  mechanism_icon,
  date_icon,
  ai_indexes_icon,
  new_icon_game,
  equal_thin_icon,
  metamask_icon,
  error_icon,
  beta_icon,
  ach_check_checked_3,
  ach_check_unchecked_3,
  ach_check_checked_3_dark,
}
